import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import _ from 'lodash';

export const nestDeviceTypes = {
  cameras: {
    model: 'nest-camera'
  },
  smoke_co_alarms: {
    model: 'nest-protect'
  },
  thermostats: {
    model: 'nest-thermostat'
  }
};

export type NestDevice = {
  deviceId: string;
  name: string;
  type: string;
};

@Injectable()
export class NestService {
  public static readonly NEST_MODEL = 'nest';
  public static readonly ACCESS_TOKEN_URL = 'https://api.home.nest.com/oauth2/access_token';
  public static readonly API_URL = 'https://developer-api.nest.com';

  constructor(private http: Http) {}

  public getNestToken(account: any): any {
    const nestAccount = _.get(account, 'externalAccounts', []).find(
      (acc: any) => acc.type === NestService.NEST_MODEL
    );

    return nestAccount ? _.get(nestAccount, 'access_token') : null;
  }

  public requestAccessToken(
    clientId: string,
    clientSecret: string,
    code: string
  ): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const bodyParams = new URLSearchParams();
    bodyParams.append('client_id', clientId);
    bodyParams.append('client_secret', clientSecret);
    bodyParams.append('grant_type', 'authorization_code');
    bodyParams.append('code', code);

    return this.http
      .post(NestService.ACCESS_TOKEN_URL, bodyParams, { headers })
      .map((res) => res.json());
  }

  public readAllData(accessToken: string): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${accessToken}`);

    return this.http
      .get(NestService.API_URL, { headers })
      .map((res) => res.json());
  }
}
